<template>
  <div>
    <h3>会员配额</h3>
    <p class="hint">BETA_FREE 与 FREE 共用 FREE 方案限额。修改后立即生效；单文件上限不得超过当前环境硬顶。测试期 FREE 为 1.5GB/60min，正式收费后应恢复 1GB/45min。</p>
    <el-table v-loading="loading" :data="plans" stripe class="quota-table">
      <el-table-column label="方案" width="130">
        <template slot-scope="{ row }">{{ planLabel(row.planCode) }}</template>
      </el-table-column>
      <el-table-column prop="planCode" label="代码" width="100" />
      <el-table-column label="单文件(MB)" width="150">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.maxFileMb" class="quota-input quota-input--wide" :min="1" :max="20480" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="时长(min)" width="140">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.maxDurationMin" class="quota-input" :min="1" :max="600" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="切片/日" width="130">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.slicesPerDay" class="quota-input" :min="1" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="切片/月" width="130">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.slicesPerMonth" class="quota-input" :min="1" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="并行任务" width="130">
        <template slot-scope="{ row }">
          <el-input-number v-model="row.maxRunningTasks" class="quota-input" :min="1" :max="10" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="优先队列" width="90">
        <template slot-scope="{ row }"><el-switch v-model="row.priorityQueue" /></template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="applyRecommended(row)">填入推荐</el-button>
          <el-button type="primary" size="mini" @click="save(row)">保存</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="recommended-section">
      <h4>推荐配置（产品默认）</h4>
      <p class="hint">以下为文档约定推荐值，供对照；与上表 DB 实际配置可能不同。FREE 测试期临时 1.5GB/60min；PRO 1.5GB，PRO_PLUS 2GB。</p>
      <el-table :data="recommendedPlans" stripe size="small" class="recommended-table">
        <el-table-column label="方案" width="130">
          <template slot-scope="{ row }">{{ recommendedPlanLabel(row.planCode) }}</template>
        </el-table-column>
        <el-table-column prop="planCode" label="代码" width="100" />
        <el-table-column prop="maxFileMb" label="单文件(MB)" width="100" />
        <el-table-column prop="maxDurationMin" label="时长(min)" width="90" />
        <el-table-column prop="slicesPerDay" label="切片/日" width="80" />
        <el-table-column prop="slicesPerMonth" label="切片/月" width="80" />
        <el-table-column prop="maxRunningTasks" label="并行" width="70" />
        <el-table-column label="优先队列" width="90">
          <template slot-scope="{ row }">{{ row.priorityQueue ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="note" label="说明" min-width="200" show-overflow-tooltip />
      </el-table>
    </div>
  </div>
</template>

<script>
import { fetchQuotaPlans, updateQuotaPlan } from '../api/admin';
import { planLabel } from '../constants/planLabels';
import { RECOMMENDED_QUOTA_PLANS, recommendedPlanLabel } from '../constants/quotaRecommendations';

export default {
  name: 'QuotaPlans',
  data() {
    return {
      loading: false,
      plans: [],
      recommendedPlans: RECOMMENDED_QUOTA_PLANS,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    planLabel,
    recommendedPlanLabel,
    async load() {
      this.loading = true;
      try {
        this.plans = await fetchQuotaPlans();
      } catch (e) {
        this.$message.error(e.message || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    applyRecommended(row) {
      const rec = this.recommendedPlans.find(p => p.planCode === row.planCode);
      if (!rec) {
        this.$message.warning('该方案暂无推荐配置');
        return;
      }
      row.maxFileMb = rec.maxFileMb;
      row.maxDurationMin = rec.maxDurationMin;
      row.slicesPerDay = rec.slicesPerDay;
      row.slicesPerMonth = rec.slicesPerMonth;
      row.maxRunningTasks = rec.maxRunningTasks;
      row.priorityQueue = rec.priorityQueue;
      this.$message.success('已填入推荐值，请确认后保存');
    },
    async save(row) {
      try {
        await this.$confirm(`确认保存「${planLabel(row.planCode)}」配额？`, '确认', { type: 'warning' });
        await updateQuotaPlan(row.planCode, row);
        this.$message.success('已保存');
        this.load();
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '保存失败');
        }
      }
    },
  },
};
</script>

<style scoped>
.hint { color: #6b7280; font-size: 13px; margin-bottom: 12px; }
.recommended-section { margin-top: 28px; }
.recommended-section h4 { margin: 0 0 8px; font-size: 15px; color: #374151; }
.recommended-table { margin-top: 8px; }
/* el-input-number 默认约 130px，列宽不足时右侧加号会被 table cell 裁切 */
.quota-table >>> .cell { overflow: visible; }
.quota-input { width: 118px; }
.quota-input--wide { width: 130px; }
</style>
